import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Typography, Stack } from "@mui/material";
export const JobCountdownTimer = ({ job, modelDuration, onCountdownComplete, }) => {
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [hasCompleted, setHasCompleted] = useState(false);
    useEffect(() => {
        if (job.jobStatus !== "processing" || !job.startedAt || !modelDuration) {
            setTimeRemaining(null);
            setHasCompleted(false);
            return;
        }
        const calculateTimeRemaining = () => {
            const now = Date.now();
            const expectedCompletionTime = job.startedAt + modelDuration * 1000;
            const remaining = Math.max(0, expectedCompletionTime - now);
            // Only call callback once when reaching zero
            if (remaining === 0 && !hasCompleted) {
                setHasCompleted(true);
                onCountdownComplete();
            }
            return remaining;
        };
        // Initial calculation
        const initial = calculateTimeRemaining();
        setTimeRemaining(initial);
        // Set up interval to update every second
        const interval = setInterval(() => {
            const remaining = calculateTimeRemaining();
            setTimeRemaining(remaining);
        }, 1000);
        return () => clearInterval(interval);
    }, [job.jobStatus, job.startedAt, modelDuration, hasCompleted]);
    if (job.jobStatus !== "processing" || timeRemaining === null) {
        return null;
    }
    const formatTime = (ms) => {
        const totalSeconds = Math.ceil(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        }
        return `${seconds}s`;
    };
    return (_jsx(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 1, sx: { width: "100%", display: "flex", justifyContent: "center" } }, { children: _jsx(Typography, Object.assign({ variant: "body1", color: "primary", fontWeight: "bold" }, { children: formatTime(timeRemaining) })) })));
};
